import { useContext, useEffect, useState } from "react";
import { Card, Col, Form, FormCheck, Row } from "react-bootstrap";
import { DEFAULT_MESSAGE, NOTES, SEND_MESSAGE } from "../../util/const";
import { ReviewContext } from "../ReviewPatient";
import { FormatDateForDisplay } from "../../util/data-utils";


const ReviewOutcome = () => 
{
  const context = useContext(ReviewContext);
  const patient = context.patient;

  const [message, setMessage] = useState("")
  const [note, setNote] = useState("")

  // This is called every time the user clicks next, prev patient
  // We need to set the note and message for the selected patient
  // to replace the values of the previous patient
  useEffect(() => 
  {
    // initialise if necessary to avoid 
    // null pointer when variables are set
    if(patient.currentReview == null)
    {
      patient.currentReview = {
        reviewDate: "",
        message: "",
        note: "",
        messageRead:false,
        enteredInError:false,
      }
    }
    
    setNote(patient.currentReview.note);
    setMessage(patient.currentReview.message);
    
    //TODO: investigate the useReducer hook to prevent repeated 
    //renders when setting more than one varable at a time
  }, [patient]); 

  const handleMessageChange = (smsMessage:string) => 
  {
    patient.currentReview.message = smsMessage;
    setMessage(smsMessage);
  }

  const handleNoteChange = (reviewNote:string) => 
  {
    patient.currentReview.note = reviewNote;
    setNote(reviewNote);
  }

  const toggleUseDefaultMessage = (e: React.ChangeEvent<HTMLInputElement>) =>
  {
    if(e.target.checked)
    {
      handleMessageChange(DEFAULT_MESSAGE);
      return;
    }
    handleMessageChange("");
  }

  const messageLength = () => {
    if(message == null || message === undefined)
      return 0;
    return message.length;
  }

  return (
    <Row>
      <Col>
        <Card>
          <Card.Header className="fs-5">
            <Row>
              <Col>
                {SEND_MESSAGE}:
              </Col>
              {/* <Col className="right">
                <Button id="btn-send" type="button" className='fs-6 btn-color' onClick={handleSend}>{SEND}</Button>
              </Col> */}
            </Row>
          </Card.Header>
          <Card.Body className="review-card">
            <FormCheck id="switch-default" type="switch" onChange={toggleUseDefaultMessage} label="Use default message"/>
            <Form.Control as="textarea" rows={4} id="txt-sms" className="mb-2 mt-3" maxLength={600} value={message} onChange={e => handleMessageChange(e.target.value)} />
            <Col className="right small"><Form.Text muted>{messageLength()} of 600 characters</Form.Text></Col>
          </Card.Body>
        </Card>
      </Col>
      <Col>
        <Card>
          <Card.Header className="fs-5">
            <Row>
              <Col>
                {NOTES}:
              </Col>
            </Row>
          </Card.Header>
          <Card.Body className="review-card">
            <Form.Text className="fs-6" muted>{patient.givenNames} {patient.familyName} | DOB: {FormatDateForDisplay(patient.birthDate)} | URN: {patient.urn}</Form.Text>
            <Form.Control as="textarea" rows={4} id="txt-note" name="txt-note" className="mt-3" value={note} onChange={e => handleNoteChange(e.target.value)}/>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  )
}

export default ReviewOutcome;